import { UTA_FORM_TA_FIELD_ENUM } from '@components-member/TradingAccounts/AccountCreate/enums';
import {
  COPYTYPE_FIELD,
  IBCODE_FIELD,
  LEVERAGE_FIELD,
} from '@components-member/TradingAccounts/AccountCreate/sharedFields';
import {
  MARGIN_STOP_COPY_LEVEL,
  PERCENTAGE_LOSS_STOP_COPY_LEVEL,
  TYPE_FIELD,
  LOT_FIELD,
  STOP_COPY_VIA_MARGIN_LEVEL,
} from '@components-member/shared/forms/formFields';
import { IModalFormField } from '@components-member/socialTrading/social.interfaces';
import { keyMap } from '@locales/lokalise/keyMap';
// @ts-ignore: remove after translating into typescript
import generator from 'components/shared/forms/formGenerator';
import { COPY_TYPE } from 'global.enums';

export const INVESTOR_ACCOUNT_FIELDS: IModalFormField[] = [
  {
    name: UTA_FORM_TA_FIELD_ENUM.masterAccountId,
    type: 'selectWithExtendedOptions',
    options: [],
    descriptionComponent: null,
    notificationComponent: null,
    attributes: { autoComplete: 'off' },
    required: true,
    title: keyMap.copyTradingMasterForCopy,
    className: 'full-width',
    placeholder: keyMap.mastersSelectPlaceholder,
    accountData: {},
  },
  {
    ...TYPE_FIELD,
    name: UTA_FORM_TA_FIELD_ENUM.type,
    title: keyMap.sharedFieldsAccountType,
    attributes: { autoComplete: 'off', disabled: true },
    required: true,
  },
  {
    ...COPYTYPE_FIELD,
    options: [],
    attributes: { autoComplete: 'off', disabled: true },
  },
  {
    ...LEVERAGE_FIELD,
    attributes: { autoComplete: 'off', disabled: true },
  },
  {
    ...IBCODE_FIELD,
  },
  { ...LOT_FIELD },
  { ...MARGIN_STOP_COPY_LEVEL },
  { ...STOP_COPY_VIA_MARGIN_LEVEL },
  { ...PERCENTAGE_LOSS_STOP_COPY_LEVEL },
];

type InvestorAccountFormContext = {
  props: {
    lotFieldHandler: (value: COPY_TYPE) => void;
  };
};

export const InvestorAccountForm = generator(INVESTOR_ACCOUNT_FIELDS, {
  copyType: (ctx: InvestorAccountFormContext, value: COPY_TYPE) => {
    const { lotFieldHandler } = ctx.props;

    if (lotFieldHandler) {
      lotFieldHandler(value);
    }
  },
});
